<template>
  <v-app style="background-image: linear-gradient(to bottom,rgba(187, 35, 35, 0.73), rgba(58, 18, 18, 0.73)), url('https://images.unsplash.com/photo-1529539795054-3c162aab037a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8bG9naW58ZW58MHx8MHx8&w=1000&q=80');background-size:cover;">
    <div style="text-align:right">
      <a href="https://worldwin.co.in/" target="_blank">
        <v-btn class="ma-2 txt_dec" outline large fab color="orange">
        <v-icon class="vbtn" color="white">close</v-icon>
        </v-btn>
      </a>
    </div>
    <v-content>
      <v-container>
        <div style="text-align:center;padding-top:4%">
          <a to="/worldwin" href="">
          <img  class="center" src="../../assets/worldwin-logo-1.png" />
            </a>
          <h1 style="font-weight:bold;font-size:50px;color:whitesmoke;">Worldwin Login Panel</h1>
          <p style="color:whitesmoke;" class="txt">C h o o s e &nbsp;&nbsp; Y o u r &nbsp;&nbsp; C a t e g o r y &nbsp;&nbsp; t o  &nbsp;&nbsp; L o g i n</p>
          <div class="row" style="margin:0px;padding-top:35px;">
            <div class="col">
              <a href="https://abroadadm.worldwin.org/" class="txt_dec" target="_blank">
                <v-card style="text-align:center;background-color:#e0e0e0;cursor:pointer;border-radius:10px;">
                <v-container>
                  <v-btn class="ma-2" outline large fab color="orange">
                   <v-icon class="vbtn">group</v-icon>
                  </v-btn>
                  <h4 style="font-weight:bold;font-size:18px;">C R M</h4>
                </v-container>
              </v-card>
              </a>   
            </div>
            <div class="col">
              <a href="https://webmail.worldwin.co.in/" class="txt_dec" target="_blank">
                <v-card style="text-align:center;background-color:#e0e0e0;cursor:pointer;border-radius:10px;">
                <v-container>
                  <v-btn class="ma-2" outline large fab color="orange">
                   <v-icon class="vbtn">mail_outline</v-icon>
                  </v-btn>
                  <h4 style="font-weight:bold;font-size:18px;">W E B M A I L</h4>
                </v-container>
              </v-card>
              </a>
            </div>
            <div class="col">
              <a href="#" class="txt_dec" target="_blank">
                <v-card style="text-align:center;background-color:#e0e0e0;cursor:pointer;border-radius:10px;">
                <v-container>
                  <v-btn class="ma-2" outline large fab color="orange">
                   <v-icon class="vbtn">manage_accounts</v-icon>
                  </v-btn>
                  <h4 style="font-weight:bold;font-size:18px;">C M S</h4>
                </v-container>
              </v-card>
              </a>
            </div>
            <div class="col">
              
              <v-card style="text-align:center;background-color:#e0e0e0;cursor:pointer;border-radius:10px;">
                <v-container>
                  <v-btn to="/studentLogin" class="ma-2" outline large fab color="orange">
                   <v-icon class="vbtn">school</v-icon>
                  </v-btn >
                  <h4 style="font-weight:bold;font-size:18px;">S T U D E N T</h4>
                </v-container>
              </v-card>
            </div>

            <div class="col">
              
              <v-card style="text-align:center;background-color:#e0e0e0;cursor:pointer;border-radius:10px;">
                <v-container>
                  <v-btn to="/subagentlogin" class="ma-2" outline large fab color="orange">
                   <v-icon class="vbtn">people</v-icon>
                  </v-btn >
                  <h4 style="font-weight:bold;font-size:18px;">P A R T N E R</h4>
                </v-container>
              </v-card>
            </div>
                        <div class="col">
              <v-card style="text-align:center;background-color:#e0e0e0;cursor:pointer;border-radius:10px;">
                <v-container>
                  <v-btn class="ma-2" outline large fab color="orange">
                   <v-icon class="vbtn">person_outline</v-icon>
                  </v-btn>
                  <h4 style="font-weight:bold;font-size:18px;">T E A C H E R</h4>
                </v-container>
              </v-card>
            </div>
          </div>

        </div>
      </v-container>
    </v-content>

    <!-- <v-footer class="black--text pa-4" style="background-color:#fcd5a6">
      <v-spacer></v-spacer>
      <div>
        &copy; {{ new Date().getFullYear() }} Developed with 💖 by
        <a
          href="http://infosyst.in/"
        >Infosyst</a>
      </div>&nbsp;&nbsp;&nbsp;&nbsp;
    </v-footer> -->
  </v-app>
</template>

<script>
import config from "../../config.json";
//import vuetifyToast from "vuetify-toast";
export default {
  data: () => ({
    menu: false,
    loading: false,
    dialog: false,
    otpDialog: false,
    loginBtn: false,
    signinBtn: false,
    submitBtn: false,
    drawer: null,
    UserName: null,
    Password: null,
    passwordShow: false,
    role: sessionStorage.roles,
    registerDialog: false,
    valid: true,

    countDown : 120,

    hey: null,

    
    form1: {
      otp: null
    },

    otp: null,

    form: {
      mobileNumber: null,
      email: null,
      passwords: null
    },

    emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
        min: value =>
          (value != null && value.length >= 6) || "Min 6 characters",
        number: value => {
          const pattern = /[0-9]+/;
          return pattern.test(value) || "Min one number";
        },
        capital: value => {
          const pattern = /[A-Z]+/;
          return pattern.test(value) || "Min one capital letter";
        },
        small: value => {
          const pattern = /[a-z]+/;
          return pattern.test(value) || "Min one small letter";
        },
        spec: value => {
          const pattern = /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]+/;
          return pattern.test(value) || "Min one special character";
        }
      },
  }),
  props: {
    source: String
  },

  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.loginBtn = true;
        this.otp = 1234;  /* Math.floor(1000 + Math.random() * 9000) */
        this.axios
          .post(
            config.API + `RegistrationOtp`,
            {
              mobileNumber: this.form.mobileNumber,
              otp: JSON.parse(this.otp)
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("OTP has been Send");
            this.otpDialog = true;
            this.loginBtn = false;
          })
          .catch(() => {
            this.$toaster.error('Mobile Number is already registered');
            this.loginBtn = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onSubmit1() {
      if (this.$refs.form1.validate()) {
        if(this.form1.otp == this.otp) {
          this.loginBtn = true;
        this.axios
          .post(
            config.API + `Registration`,
            {
              mobileNumber: this.form.mobileNumber,
              type: "Customer"
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(resp => {
            const token = resp.data.token.value.token;
            const menus = resp.data.menus;
            const loggedInUserName = resp.data.loggedInUserName;
            const loggedInUserID = resp.data.loggedInUserID;
            const roles = resp.data.roles;
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("loggedInUserName", loggedInUserName);
            sessionStorage.setItem("loggedInUserID", loggedInUserID);
            sessionStorage.setItem("roles", roles);
            sessionStorage.setItem("menus", JSON.stringify(menus));
            this.axios.defaults.headers.common["Authorization"] = token;
            this.$toaster.success("Successfully Registered");
            this.$router.go(-1);
          })
          .catch(() => {
            this.$toaster.error('Wrong OTP');
            this.loginBtn = false;
          });
        }
        else {
          this.$toaster.error('Wrong OTP');
          this.loginBtn = false;
        }
        
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onSubmit2() {
      if (this.$refs.form.validate()) {
        this.loginBtn = true;
        this.otp = 1234;
        //this.otp = Math.floor(1000 + Math.random() * 9000);
        this.axios
          .post(
            config.API + `LoginOtp`,
            {
              mobileNumber: this.form.mobileNumber,
              otp: JSON.parse(this.otp)
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("OTP has been Send");
            this.otpDialog = true;
            this.loginBtn = false;
          })
          .catch(() => {
            this.$toaster.error('Account has been deactivated');
            this.loginBtn = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onSubmit3() {
      if (this.$refs.form1.validate()) {
        if(this.form1.otp == this.otp) {
          this.loginBtn = true;
        this.axios
          .post(
            config.API + `Login`,
            {
              mobileNumber: this.form.mobileNumber
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(resp => {
            const token = resp.data.token.value.token;
            const menus = resp.data.menus;
            const loggedInUserName = resp.data.loggedInUserName;
            const loggedInUserID = resp.data.loggedInUserID;
            const roles = resp.data.roles;
            const active = resp.data.active;
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("active", active);
            sessionStorage.setItem("loggedInUserName", loggedInUserName);
            sessionStorage.setItem("loggedInUserID", loggedInUserID);
            sessionStorage.setItem("roles", roles);
            sessionStorage.setItem("menus", JSON.stringify(menus));
            this.axios.defaults.headers.common["Authorization"] = token;
            this.$router.go(-1);
          })
          .catch(() => {
            this.$toaster.error('Wrong OTP');
            this.loginBtn = false;
          });
        }
        else {
          this.$toaster.error('Wrong OTP');
          this.loginBtn = false;
        }
        
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    register() {
      this.registerDialog = true;
      this.type = "Customer";
    },
    loginPage() {
      this.registerDialog = false;
    },
    login() {
      this.loginBtn = true
      let UserName = this.UserName;
      let Password = this.Password;
      this.loading = true;
      this.$store
        .dispatch("login", { UserName, Password })
        .then(() => {
          /* if (sessionStorage.roles === 'Member') {
            this.$router.go(-1);
            this.loading = false;
          }
          else { */
            //this.$router.push("/_");
            this.$router.go(-1);
            this.loading = false;
          /* } */
        })
        .catch(err => {
          this.loading = false;
          this.loginBtn = false;
        });

    },

    countDownTimer() {
             
               if(this.countDown > 0) {
                    setTimeout(() => {
                        this.countDown -= 1
                        this.countDownTimer()
                    }, 1000)
                }
                else {
                  this.otpDialog = false;
                }
            },

    forgotPassword() {
      this.$router.push("/forgotPassword");
    },

    homePage() {
      this.$router.push("/");
    },
    back() {
      this.$router.go(-1);
    },

    signin() {
      if (this.$refs.form1.validate()) {
        this.signinBtn = true;
        this.axios
          .post(
            config.API + `Token1`,
            {
              mobileNumber: this.form1.mobileNumber
            }
          )
          .then(() => {
            this.otpDialog = true;
            this.countDown = 120;
            this.signinBtn = false;
            //this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.signinBtn = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
        this.btnSave = false;
      }
  },

   submit() {
      if (this.$refs.form2.validate()) {
      this.submitBtn = true;
      let MobileNumber = this.form1.mobileNumber;
      let Otp = this.form2.otp;
      this.$store
        .dispatch("submit", { MobileNumber, Otp })
        .then(() => {
            this.$router.go(-1);
            this.submitBtn = false;
        })
        .catch(err => {
          this.submitBtn = false;
        });
      }
    }


  },
  created() {
    this.countDownTimer();
  }
  

  
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Mulish&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@500&display=swap');
</style>
<style lang="css" scoped>
.hdr {
 font-size: 50px;
 color: #e0e0e0;
}
.hdr1 {
 color: #e0e0e0;
}
.txt {
 font-family: 'Mulish', sans-serif;
}
.txtt {
 font-family: 'Sora', sans-serif;
}
.lftsid {
  background-color: #4E97FD !important;
  background-size: cover;
  box-shadow: none !important;
  border-radius: 0px !important;
}
.login-form {
  padding: 40px;
}
.bckcolor {
  background-image: url("../../assets/loginbg.jpg");
  background-size: cover;
}
.cursr {
  cursor: pointer;
}
.v-btn {
  margin-left: 0px;
}
.txt_dec:hover {
    pointer-events: none;
}
.loginPage {
  background-size:cover
}
.vbtn {
  border-radius: 50px !important;
}
.call-button-container {
  margin: auto;
  width: 233px;
  height: 74px;
  vertical-align: middle;
  padding: 10px;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.click:hover {
  text-decoration: underline !important;
  cursor: pointer;
}
.divc{
    position: absolute;
    top: 50%;
    left: 30%;
    margin-top: -50px;
}
</style>
